module.exports = __webpack_public_path__ + "junit5_devday.2b6f5c02e37a55f36e9b.png";